import { render, staticRenderFns } from "./WarmUp1-3.vue?vue&type=template&id=af974122&"
import script from "./WarmUp1-3.vue?vue&type=script&lang=js&"
export * from "./WarmUp1-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports